import React, { useEffect, useMemo, useState } from "react";
import DataTable from "../DataTable";
import Switch from "@mui/material/Switch";
import IconButton from "@mui/material/IconButton";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import { Button, Stack, TextField, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import SwitchButton from "../Switch";
import { useDispatch } from "react-redux";
import { editSponsor, getSponsors } from "../../redux/actions/sponsors-action";

const FilterComponent = ({ filterText, onFilter, onClear }) => (
  <>
    {/* <TextField
      id="search"
      type="text"
      placeholder="Filter By Name"
      aria-label="Search Input"
      value={filterText}
      onChange={onFilter}
    />
    <Button type="button" onClick={onClear}>
      X
    </Button> */}
  </>
);

export default function MyComponent(props) {
  const [filterText, setFilterText] = useState("");
  const [isEnabled, setIsEnabled] = useState(null);
  const [RowData, setRowData] = useState([]);
  const [sponsorStatus, setSponsorStatus] = useState("");
  const [rowStatus, setRowStatus] = useState(false);

  const [value, setValue] = useState(false);

  const dispatch = useDispatch();
  // const filteredItems = props.data.filter(
  //   (item) =>
  //     item.name && item.name.toLowerCase().includes(filterText.toLowerCase())
  // );

  // const _handleChangeStatus = (e, row, switchBool) => {
  //   if (row.status == "active") {
  //   }

  //   let data = RowData.filter((item) => {
  //     console.log("item", item);
  //     return item._id == row._id;
  //   });

  //   console.log("data", data);

  //   if (data?.status == "active") {
  //     setSponsorStatus("inactive");
  //   } else if (data?.status == "inactive") {
  //     setSponsorStatus("active");
  //   }

  //   // if (row?.status == "active") {
  //   //   setSponsorStatus("inactive");
  //   // } else {
  //   //   setSponsorStatus("active");
  //   // }

  //   const dataObj = {
  //     status: sponsorStatus,
  //   };

  //   console.log("dataObj", dataObj);
  //   // dispatch(editSponsor(row?._id, dataObj));
  //   // dispatch(getSponsors());
  //   // dispatch(getSponsors());
  //   // dispatch(getSponsors());
  //   // dispatch(getSponsors());
  //   // dispatch(getSponsors());
  //   // dispatch(getSponsors());

  //   // setStatus(e.target.checked);
  // };

  const _handleChangeStatus = () => {
    setValue((value) => !value);
    //console.log(value);

    if (value == true) {
      setSponsorStatus("active");
    } else if (value == false) {
      setSponsorStatus("inactive");
    }
  };
  //console.log("sponsorStatus", sponsorStatus);

  const subHeaderComponentMemo = useMemo(() => {
    // const handleClear = () => {
    //   if (filterText) {
    //     setFilterText("");
    //   }
    // };

    // return (
    //   <FilterComponent
    //     onFilter={(e) => setFilterText(e.target.value)}
    //     onClear={handleClear}
    //     filterText={filterText}
    //   />
    // );
  }, [filterText]);
  // const [professionList, setProfessionList] = useState([]);
  // const [show, setShow] = useState(false);
  // const [selectedRow, setSelectedRow] = useState({});

  // const baseEndpointURL =
  //   ApiEndpoints.root +
  //   ApiEndpoints.management.base +
  //   ApiEndpoints.management.profession.base;

  useEffect(() => {
    // props.getDataList();

    // console.log("props.professionList", props.professionList);
    setRowData(props.data);
    return () => {
      //   props.getDataList();
      setRowData(props.data);
    };
  }, [props.data]);

  const onChangeValue = (e, key, key2 = "") => {
    const obj = props?.selectedRows[0];
    key2 ? (obj[key][key2] = e) : (obj[key] = e);
    props?.onSelectedRowsChange({ selectedRows: props?.selectedRows });
  };

  const columns = [
    {
      name: <Typography variant="subtitle2" fontWeight={700}>Chapter</Typography>,
      selector: (row) => row.chapter,
      sortable: true,
      cell: (row, index, column, id) => {
        if (props?.edit && row?._id == props?.selectedRows[0]?._id) {
          return (
            <input
              class="cst-input"
              placeholder="Edit Input"
              defaultValue={row?.chapter}
            />
          );
        } else {
          return <p style={{ marginTop: 15 }}>{row.chapter}</p>;
        }
      },
    },
    {
      name: <Typography variant="subtitle2" fontWeight={700} sx={{ textAlign: 'center', width: '100%' }}>Name</Typography>,
      selector: (row) => row.name,
      sortable: true,
      cell: (row, index, column, id) => {
        if (props?.edit && row?._id == props?.selectedRows[0]?._id) {
          return (
            <input
              class="cst-input"
              onChange={(e) => onChangeValue(e.target?.value, "name")}
              placeholder="Name"
              defaultValue={row?.name}
            />
          );
        } else {
          return <p style={{ marginTop: 15, width: '100%', textAlign: 'center' }}>{row.name}</p>
        }
      },
    },
    {
      name: <Typography variant="subtitle2" fontWeight={700} sx={{ textAlign: 'center', width: '100%' }}>Company</Typography>,
      selector: (row) => row.company,
      sortable: true,
      cell: (row, index, column, id) => {
        if (props?.edit && row?._id == props?.selectedRows[0]?._id) {
          return (
            <input
              class="cst-input"
              onChange={(e) => onChangeValue(e.target?.value, "company")}
              placeholder="Company"
              defaultValue={row?.company}
            />
          );
        } else {
          return <p style={{ marginTop: 15, width: '100%', textAlign: 'center' }}>{row.company}</p>;
        }
      },
    },
    {
      name: <Typography variant="subtitle2" fontWeight={700}>Title</Typography>,
      selector: (row) => row.title,
      sortable: true,
      cell: (row, index, column, id) => {
        if (props?.edit && row?._id == props?.selectedRows[0]?._id) {
          return (
            <input
              class="cst-input"
              onChange={(e) => onChangeValue(e.target?.value, "title")}
              placeholder="Title"
              defaultValue={row?.title}
            />
          );
        } else {
          return <p style={{ marginTop: 15 }}>{row.title}</p>;
        }
      },
    },
    {
      name: <Typography variant="subtitle2" fontWeight={700}>Website</Typography>,
      selector: (row) => row.website,
      sortable: true,
      cell: (row, index, column, id) => {
        if (props?.edit && row?._id == props?.selectedRows[0]?._id) {
          return (
            <input
              class="cst-input"
              placeholder="Edit Input"
              defaultValue={row?.website}
            />
          );
        } else {
          return <p style={{ marginTop: 15 }}>{row.website}</p>;
        }
      },
    },
    {
      name: <Typography variant="subtitle2" fontWeight={700}>Status</Typography>,
      selector: (row) => row.status,
      cell: (row, index, column) => {
        var status = row?.status || "";
        // var switchBool = false;
        // if (row?.status != "" && status.toLowerCase() == "active")
        //   switchBool = true;
        var switchBool = row?.status?.toLowerCase() == "active" ? true : false;
        return (
          <Switch
            defaultChecked={isEnabled != null ? isEnabled : switchBool}
            onClick={(e) => {
              let switchNewsValue = "active";
              if (e?.target?.checked) {
                switchNewsValue = "active";
              } else {
                switchNewsValue = "inactive";
              }
              props.handleSwitchSponsor(row, switchNewsValue);
            }}
          // onChange={(e) => {
          //   // console.log("row", row);
          //   _handleChangeStatus(e, row, switchBool);
          // }}
          // checked={value}
          // checked={rowStatus}
          // checked={row?.status == "active" ? true : false}
          // checked={status}
          // checked={sponsorStatus == "active" ? true : false}
          />
          // <Switch
          //   defaultChecked={isEnabled != null ? isEnabled : switchBool}
          //   onClick={(e) => {
          //     onChangeValue(
          //       e?.target?.checked ? "Active" : "Inactive",
          //       "status"
          //     );
          //     setIsEnabled(e?.target?.checked);
          //   }}
          // />
        );
      },
      // sortable: true,
    },
    {
      name: <Typography variant="subtitle2" fontWeight={700}>Actions</Typography>,
      sortable: true,
      cell: (row) => {
        return (
          <>
            <IconButton
              style={{ borderRadius: 5 }}
              onClick={() => {
                props.openModal();
                props.setAddSponsor({
                  ...props.addSponsor,
                  name: row?.name,
                  company: row?.company,
                  title: row?.title,
                  status: row?.status,
                  website: row?.website,
                  // chapter: "",
                  imageFiles: row?.logo,
                });
                props.setSelectedRow(row);
                props.setAddOrEdit(true);
                // props.setselectedrows(row);
                // props.seteditVisible(!props.editVisible);
                // props.setAddCourse({
                //   ...props.addCourse,
                //   name: row?.name,
                //   address: row.address,
                //   latitude: row.latitude,
                //   longitude: row.longitude,
                //   front_9: row.course_combination[0].front_9,
                //   back_9: row.course_combination[0].back_9,
                //   status: row.status,
                // });
              }}
              color="primary"
              size="medium"
            >
              <EditRoundedIcon fontSize="medium" />
            </IconButton>
            <IconButton
              style={{ borderRadius: 5 }}
              onClick={() => {
                props.openDeleteModal();
                props.setSelectedRow(row);
                // props.onDeletePress();
                // props.setselectedrows(row);
              }}
              color="primary"
              size="medium"
            >
              <DeleteRoundedIcon fontSize="medium" />
            </IconButton>
          </>
        );
      },
    },
  ];

  const conditionalRowStyles = {
    headRow: {
      style: {
        borderStyle: "solid",
        borderWidth: "1px",
        borderColor: "rgba(0,0,0,0.6)",
        borderRadius: "5px",
      },
    },
  };

  return (
    <DataTable
      columns={columns}
      data={RowData}
      selectableRows={false}
      // subHeaderComponent={subHeaderComponentMemo}
      // subHeader
      persistTableHead
      pagination
      progressComponent={props?.progressComponent}
      progressPending={props?.progressPending}
      onChangeRowsPerPage={props?.onChangeRowsPerPage}
      paginationServer
      paginationTotalRows={10}
      clearRow={props?.clearRow}
      customStyles={conditionalRowStyles}
      direction="vertical"
      striped={true}
      onSelectedRowsChange={props?.onSelectedRowsChange}
    />
  );
}
